export default {
    data() {
        return {
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
        };
    },

    computed: {
        isMobile() {
            return this.windowWidth <= 960;
        },

        isTablet() {
            return this.windowWidth <= 1440;
        },

        isOnlyTablet() {
            return this.windowWidth <= 1440 && this.windowWidth > 960;
        },

        isComputer() {
            return this.windowWidth > 1440;
        },
    },

    mounted() {
        this.__onWindowResize = () => {
            this.windowWidth = window.innerWidth;
        };
        window.addEventListener('resize', this.__onWindowResize, { passive: true });
    },

    beforeDestroy() {
        if (this.__onWindowResize) {
            window.removeEventListener('resize', this.__onWindowResize);
        }
    }
};